import React from 'react';
import { Button, Typography } from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"

const Instructions2 = ({ dispatch }) => {
    const handleStart = () => {
        console.log("Dispatching nextTask from Instructions");
        dispatch(nextTask({}));
    };

    return (
        <PageContainer>

        <div>
            <Typography gutterBottom>
                For the last part of the survey, we're going to ask you to fill out a series of questionnaires regarding your personality, emotions and social interactions.
            </Typography>
        </div>

                    <div>

            <Button variant="contained" onClick={handleStart}>Next</Button>
        </div>
        </PageContainer>

    );
};

export default connect()(Instructions2);
